module.exports = __webpack_public_path__ + "static/media/ser-r.fca627a8.mp3";